import axios from 'axios';
let cacheMap: Record<string, string> | null = null;

export const useWCCacheMap = () => {
  const getCacheMap = async () => {
    try {
      const result = await axios.get<Record<string, string>>(
        `${process.env.VUE_APP_WC_API_URL}/web-components/cache-map.json`,
        {
          headers: {
            'Access-Control-Allow-Origin':
              (typeof location !== 'undefined' && location.origin) ||
              process.env.BASE_URL ||
              '*'
          }
        }
      );

      if (result.data) {
        cacheMap = result.data;
      }
    } catch (err) {
      console.log('Cache map error: ', err);
    }
  };

  const includeWC = async (componentName: string) => {
    if (!cacheMap) {
      await getCacheMap();
    }
    if (cacheMap && cacheMap[componentName]) {
      return `${process.env.VUE_APP_WC_API_URL}${cacheMap[componentName]}`;
    } else {
      return `${process.env.VUE_APP_WC_API_URL}/web-components/${componentName}/${componentName}.js`;
    }
  };

  const scriptLoader = async (componentName: string) => {
    const componentLink = await includeWC(componentName);
    const script = document.createElement('script');
    script.src = componentLink;

    document.head.appendChild(script);
  };

  return { includeWC, scriptLoader };
};
